import React from 'react';

/**
 * Renders the summary card component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The content to be rendered inside the card.
 * @returns {React.ReactNode} The rendered card summary component.
 */
const CardSummary = (props) => {
	return <>{props.children}</>;
};

export default CardSummary;
